/* eslint-disable */
import React, {Component, Fragment} from 'react';
import {Button, Input, Modal, Tab} from '@posco/posco-ui-react';
import {mesAutobind} from '@posco/posco-shared';

@mesAutobind
class O10g015461 extends Component {
  /**아이디 패스워드 찾기**/
    state ={
      open : false,
        // Tab
        tabInfo: [
            { menuItem: '아이디 찾기', render: () => <Tab.Pane>{this.tabContent01()}</Tab.Pane> },
            { menuItem: '비밀번호 찾기', render: () => <Tab.Pane>{this.tabContent02()}</Tab.Pane> },
        ],
    };

    // Tab
    onTabChange(e, data) {
        // console.log('탭 클리어', e, data.activeIndex);
        this.props.setTabActive(data.activeIndex);
        this.props.clearFindId();
        this.props.clearFindPW();
    }

    /**아이디 찾기 저장버튼**/
    async handleSave(e, data) {
        const findId = this.props.findId;
      const findPW = this.props.findPW;
      // console.log("저장버튼 findId", e, data, findId.length ,Object.keys(findId).length);
      // console.log("저장버튼 findPW", e, data, Object.keys(findPW).length);
      // console.log("tabActive", this.props.tabActive);


     if(this.props.tabActive === 1){
        await this.props.onFindPW(findPW);
      }
     else{ await this.props.onFindId(findId); }

      // dialog.alert(message('메일이 전송되었습니다. \n 메일을 확인해주세요'));
      //
      //   if(confirmed && rows) {
      //     const result = await this.props.onRegistBudgetInfo010(rows);
      //   }
    }

    handleCancel() {
      // console.log('cancel');
      this.props.close();
    }

    /**모달 닫기**/
  onClose() {
    // this.props.o10g015460Store.changeDisabled(true);
    this.props.close();
  }

  onChangeId(e, data) {
    // console.log("e, data===",  e, data.name, data.value);
    //이름
    if(data.name === "employeeName"){
      this.props.setFindId({...this.props.findId, employeeName: data.value});
    }
    // 이메일
    if(data.name === "emailAddress"){
      this.props.setFindId({...this.props.findId, emailAddress: data.value});
    }
  }

  onChangePw(e, data) {
    // console.log("onChangeFindPW===",  e, data.name, data.value);
    //이름
    if(data.name === "employeeName"){
      this.props.setFindPW({...this.props.findPW, employeeName: data.value});

    }
    // 이메일
    if(data.name === "emailAddress"){
      this.props.setFindPW({...this.props.findPW, emailAddress: data.value});
    }
    // 아이디
    if(data.name === "smrtNoteUserId"){
      this.props.setFindPW({...this.props.findPW, smrtNoteUserId: data.value});
    }
  }

  render() {
        const triggerList = [
            { size: 'small' },
        ];

        const { tabInfo } = this.state;

        return (
            <Fragment>
                {triggerList.map((index) => (
                  <Modal key={`o10g015461_${index}`} open={this.props.open} onClose={this.onClose} size={this.props.size || 'large'} draggable className="findingID">
                        <Modal.Header />
                        <Modal.Content>
                            <section className="o10g015461">
                                <Tab panes={tabInfo} onChange={this.onTabChange} />
                            </section>
                        </Modal.Content>
                        <Modal.Actions
                            checkButton={<Button content="확인" onClick={this.handleSave} />}
                            closeButton={<Button content="취소" onClick={this.handleCancel} />}
                        />
                    </Modal>
                    ))}
            </Fragment>
        )
    }

    // tab content - 아이디 찾기
    tabContent01() {
        return (
            <>
                <div className="findingWrap">
                    <ul>
                        <li>
                            <span>이름</span>
                          <Input
                            type="text"
                            name={"employeeName"}
                            value={this.props.findId.employeeName}
                            onChange={this.onChangeId}
                          />
                        </li>
                        <li>
                            <span>이메일 주소</span>
                          <Input
                            type="text"
                            name={"emailAddress"}
                            value={this.props.findId.emailAddress}
                            onChange={this.onChangeId}
                          />
                        </li>
                    </ul>
                </div>

                <p>
                    <span /><span /> 투자관리시스템 권한신청 시 등록하신 정보를 입력하십시오.
                </p>
                <p>
                    <span /><span /> 정보 일치시 해당 E-Mail로 ID를 전달합니다.
                </p>
            </>
        );
    }

    // tab content - 비밀번호 찾기
    tabContent02() {
        return (
            <>
                <div className="findingWrap">
                    <ul>
                        <li>
                            <span>이름</span>
                          <Input
                            type="text"
                            name={"employeeName"}
                            value={this.props.findPW.employeeName}
                            onChange={this.onChangePw}
                          />
                        </li>
                        <li>
                          <span>이메일 주소</span>
                          <Input
                            type="text"
                            name={"emailAddress"}
                            value={this.props.findPW.emailAddress}
                            onChange={this.onChangePw}
                          />
                        </li>
                        <li>
                            <span>아이디</span>
                          <Input
                            type="text"
                            name={"smrtNoteUserId"}
                            value={this.props.findPW.smrtNoteUserId}
                            onChange={this.onChangePw}
                          />
                        </li>
                    </ul>
                </div>

                <p>
                    <span /><span /> 투자관리시스템 권한신청 시 등록하신 정보를 입력하십시오.
                </p>
                <p>
                    <span /><span /> 정보 일치시 해당 E-Mail로 임시 비밀번호를 전달합니다.
                </p>
            </>
        );
    }
}
export default O10g015461;
